import { PUBLIC_API_URL, PUBLIC_PRIVATE_API_URL } from '$env/static/public';

import { browser } from '$app/environment';

import type { RequestEvent } from '@sveltejs/kit';

export class Api {
  baseUrl = PUBLIC_API_URL;

  constructor(protected fetch: RequestEvent['fetch']) {
    this.determineContextualBaseUrl();
  }

  private determineContextualBaseUrl() {
    if (!browser) {
      this.baseUrl = PUBLIC_PRIVATE_API_URL;
    }
  }
}
